<template>
    <div class="home">
<!--        <div class="van-doc-intro" v-if="isShowToast">-->
        <van-loading v-if="uploadLoading" size="24px" vertical>上传中...</van-loading>
        <div style="height: calc(100vh - 100px); overflow: auto;">
            <div :key="image" v-for="image in base64List" style="padding: 0 10px" class="demo-lazyload">
                <van-image #content
                           width="100%"
                           height="calc(9*100vw/16)"
                           :src="image"
                           @click="() => album(image)"
                />
                <van-icon name="cross" class="badge-icon van-badge--fixed van-badge" @click="delImage(image)"
                          v-if="image != require('../../assets/image/addimgbg.jpg')"/>
            </div>
        </div>
        <van-row class="btn_view " gutter="1">
            <!--<van-col span="12">
                <van-button color="#6685a4" block size="small" type="info" @click="album"
                            style="font-size: 16px;height: 60px">拍照
                </van-button>
            </van-col>-->
            <van-col span="24">
                <van-button color="#6685a4" block size="small" type="info" @click="uploadImg"
                            style="font-size: 16px;;height: 60px">上传
                </van-button>
            </van-col>
        </van-row>
        <!--        <div class="btn_view">-->
        <!--            <van-button type="info" @click="camera">拍照上传</van-button>-->
        <!--        </div>-->
    </div>
</template>

<script>
    import Vue from 'vue'
    import {uuid} from 'vue-uuid'; // uuid object is also exported to things
    import {CellGroup} from 'vant';
    import {Loading} from 'vant';

    Vue.use(Loading);
    Vue.use(CellGroup);
    import {
        Button,
        Calendar,
        Cell,
        Col,
        Divider,
        Field,
        Form,
        Grid,
        GridItem,
        Icon,
        Image as VanImage,
        ImagePreview,
        Lazyload,
        List,
        NavBar,
        Picker,
        Popup,
        PullRefresh,
        Radio,
        RadioGroup,
        Row,
        Search,
        Sticky,
        SwipeCell,
        Toast
    } from 'vant';
    import {resCode} from "../../utils/tools";
    import wx from 'weixin-js-sdk';
    import html2canvas from 'html2canvas'
    import service from '../../server/index'
    import COS from 'cos-js-sdk-v5'
    var Minio = require('minio')
    Vue.use(Lazyload, {
        lazyComponent: true,
    });

    export default {
        name: "Fleet",
        components: {
            [NavBar.name]: NavBar,
            [Search.name]: Search,
            [List.name]: List,
            [Col.name]: Col,
            [Row.name]: Row,
            [Cell.name]: Cell,
            [SwipeCell.name]: SwipeCell,
            [Button.name]: Button,
            [Popup.name]: Popup,
            [Icon.name]: Icon,
            [Field.name]: Field,
            [PullRefresh.name]: PullRefresh,
            [Sticky.name]: Sticky,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Calendar.name]: Calendar,
            [Divider.name]: Divider,
            [VanImage.name]: VanImage,
            [ImagePreview.Component.name]: ImagePreview.Component,
            [Grid.name]: Grid,
            [GridItem.name]: GridItem,
            [Form.name]: Form,
            [Picker.name]: Picker
        },
        computed: {},
        data() {
            return {
                isShowToast: true,
                uploadLoading: false,
                imageList: [],
                minioClient:undefined,

                base64List: [require('../../assets/image/addimgbg.jpg'),],
                loading: true,
                finished: false,
                isLoading: false,
                page: 1,
                pageSize: 20,
                showDetailCont: false,
                detailData: {
                    newsContent: undefined,
                    newsTitle: undefined,
                    newsTypeName: undefined,
                    createPerson: undefined,
                    auditTime: undefined,
                    newsId: undefined,
                    attaches: [],
                },
                showAttach: false,
                key: '',
                imgtu: "",
                isshow: true,
                shareshow: false,
                tmpToken: ""
            }
        },
        mounted() {
            this.onLoad();
        },
        methods: {
            showUrl(item) {
                console.log('item:  ', item.attachUrl)
            },
            openScan(newsId) {
                console.log(newsId, this.$refs[newsId])
                html2canvas(this.$refs[newsId][0], {
                    useCORS: true,
                    backgroundColor: null
                })
                    .then(canvas => {

                        let base64 = canvas.toDataURL('images/jpg')
                        console.log(base64)
                        this.imgtu = base64
                        this.shareshow = true
                        // this.savePicture(base64);
                    })
                // let params = {
                //     url: window.location.href.split("#")[0],
                //     appName:process.env.VUE_APP_NAME
                // }
                // service.getWxconfig(params).then((res)=>{
                //     // alert(JSON.stringify(res));
                //     if(res.code==200){
                //         wx.config({
                //             debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                //             appId: res.data.appId, // 必填，公众号的唯一标识
                //             timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                //             nonceStr: res.data.noncestr, // 必填，生成签名的随机串
                //             signature: res.data.signature,// 必填，签名
                //             jsApiList: ['updateAppMessageShareData','updateTimelineShareData'] // 必填，需要使用的JS接口列表
                //         });
                //
                //         wx.checkJsApi({
                //             jsApiList: ['updateTimelineShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                //             success: function(res) {
                //                 // 以键值对的形式返回，可用的api值true，不可用为false
                //                 // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
                //                 console.log("do wx checkJsApi",res)
                //             }
                //         });
                //
                //
                //         wx.ready(function () {//需在用户可能点击分享按钮前就先调用
                //             console.log("do wx ready")
                //             wx.updateTimelineShareData({
                //                 title: '行情资讯', // 分享标题
                //                 link: 'https://wechat.24991880.com/#/Home/SummaryList', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                //                 desc: 'desc',
                //                 imgUrl: 'https://wechat.24991880.com/img/rherw.29fd564f.jpg', // 分享图标
                //                 success: function () {
                //                     // 设置成功
                //                     // alert("chengong")
                //                     Toast("分享成功")
                //                 }
                //             })
                //         });
                //
                //
                //         wx.error(function(res){
                //             console.log("wx error:",res)
                //             alert(res.errMsg);
                //             //config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                //         });
                //
                //
                //     }
                // }).catch((res)=>{
                //     console.log("Catch",res);
                // });
            },
            delImage(image) {
                this.base64List.splice(this.base64List.findIndex(v => v === image), 1)
            },
            onRefresh() {
                this.onLoad();
            },
            showDetail(newsId) {
                console.log(newsId)
                // 没有点击事件
                // this.showDetailCont = true
                // this.selNewsByIDG(newsId)
            },
            selNewsByIDG(newsId) {
                let param = {
                    newsId: newsId,
                    readPersonId: localStorage.getItem('userId'),
                }
                let url = process.env.VUE_APP_API + process.env.VUE_APP_NAME
                service.selNewsByIDG(url, param).then(res => {
                    if (res.code == resCode.success) {
                        this.detailData = res.data
                        if (res.data.attaches.length > 0) {
                            this.showAttach = true
                        } else {
                            this.showAttach = false
                        }
                    } else {
                        Toast(res.msg)
                    }
                })
            },
            back() {
                this.$router.replace("/Home/Search")
            },
            addPop() {
                this.show = true;
                this.addShowPop = true;
            },
            onSearch() {
                this.list = [];
                this.page = 1;
                this.onLoad();
            },
            onLoad() {
                this.selNewsG();
            },
            selNewsG() {
                let param = {
                    page: this.page,
                    count: this.pageSize,
                    ouid: process.env.VUE_APP_OUID,
                    newsTypeId: 2,
                    key: this.key,
                }
                let url = process.env.VUE_APP_API + process.env.VUE_APP_NAME
                service.selNewsG(url, param).then(res => {
                    if (res.code == resCode.success) {
                        if (res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                this.list.push(res.data[i]);
                            }
                            this.page++
                        } else {
                            this.finished = true;
                        }
                        // 加载状态结束
                        this.loading = false;
                        this.isLoading = false;
                        // let _this=this
                        // setTimeout(function()  {
                        //
                        //     _this.openScan()//娃娃消失
                        //
                        // }, 2000);
                    } else {
                        this.loading = false;
                        this.finished = true;
                        this.isLoading = false;
                        Toast(res.msg)
                    }
                })
            },

            album(image) {
                if (image == require('../../assets/image/addimgbg.jpg')) {
                    var self = this;
                    this.isShowToast = false
                    let params = {
                        url: window.location.href.split("#")[0],
                        appName: process.env.VUE_APP_NAME,
                        ouid:process.env.VUE_APP_WECHAT_OUID
                    }
                    service.getWxconfig(params).then((res) => {
                        // alert(JSON.stringify(res));
                        if (res.code == 200) {
                            wx.config({
                                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                                appId: res.data.appId, // 必填，公众号的唯一标识
                                timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                                nonceStr: res.data.noncestr, // 必填，生成签名的随机串
                                signature: res.data.signature,// 必填，签名
                                jsApiList: ['chooseImage'] // 必填，需要使用的JS接口列表
                            });

                            wx.ready(function () {//需在用户可能点击分享按钮前就先调用
                                console.log("do wx ready")
                                wx.chooseImage({
                                    count: 1, // 默认9
                                    sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
                                    sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
                                    success: function (res) {
                                        var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                                        console.log("localIds", localIds)
                                        self.imageList = localIds;
                                        for (let i = 0; i < localIds.length; i++) {
                                            self.showImg(localIds[i])
                                            console.log("selected img:", localIds[i]);
                                        }
                                    }
                                });
                            });
                            wx.error(function (res) {
                                console.log("wx error:", res)
                                alert(res.errMsg);
                                //config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                            });
                        }
                    }).catch((res) => {
                        console.log("Catch", res);
                    });
                }
            },
            showImg(id) {
                let self = this;
                console.log("id", id)
                let params = {
                    url: window.location.href.split("#")[0],
                    appName: process.env.VUE_APP_NAME,
                    ouid:process.env.VUE_APP_WECHAT_OUID
                }
                service.getWxconfig(params).then((res) => {
                    // alert(JSON.stringify(res));
                    if (res.code == 200) {
                        wx.config({
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: res.data.appId, // 必填，公众号的唯一标识
                            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                            nonceStr: res.data.noncestr, // 必填，生成签名的随机串
                            signature: res.data.signature,// 必填，签名
                            jsApiList: ['getLocalImgData'] // 必填，需要使用的JS接口列表
                        });
                        wx.ready(function () {//需在用户可能点击分享按钮前就先调用
                            wx.getLocalImgData({
                                localId: id, // 图片的localID
                                success: function (res) {
                                    console.log("localData", res.localData)
                                    if (res.localData.indexOf('data:image') != 0) {
                                        //判断是否有这样的头部
                                        res.localData = 'data:image/jpeg;base64,' + res.localData
                                    }
                                    res.localData = res.localData.replace(/\r|\n/g, '').replace('data:image/jgp', 'data:image/jpeg')
                                    self.base64List.push(res.localData)
                                    // return  res.localData; // localData是图片的base64数据，可以用img标签显示
                                }
                            });
                        });
                        wx.error(function (res) {
                            console.log("wx error:", res)
                            alert(res.errMsg);
                            //config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                        });
                    }
                }).catch((res) => {
                    console.log("Catch", res);
                });
            },
            uploadImg() {
                // let appid=this.getQueryVariable("appid")
                let appid = this.$route.params.appid
                // let ouid=this.getQueryVariable("ouid")
                let ouid = this.$route.params.ouid
                let origin = this.$route.params.origin
                let folder = "/" + appid + "/" + ouid + "/outOrder/" + Vue.prototype.$moment(new Date()).format('YYYYMM') + "/";
                let imageList = JSON.parse(JSON.stringify(this.base64List))
                imageList.splice(imageList.findIndex(v => v === require('../../assets/image/addimgbg.jpg')), 1)
                if (imageList.length == 0) {
                    Toast('请先点击拍照按钮上传图片')
                } else {
                    this.uploadLoading = true
                    for (let i = 0; i < imageList.length; i++) {
                        let filename = uuid.v1() + i + ".jpg";
                        let fileObj = this.dataURLtoFile(imageList[i], filename);
                        let url = process.env.VUE_APP_API;
                        let serveName = process.env.VUE_APP_NAME;
                        let thirdApp = process.env.VUE_APP_THIRDAPP_USERNAME;
                        let thirdPWD = process.env.VUE_APP_THIRDAPP_PASSWORD;

                        if(origin==="t"){
                            service.getAuthentication(url + serveName, "", {
                                username: thirdApp,
                                password: thirdPWD
                            }).then(auth => {
                                if (auth.code == 200) {
                                    this.tmpToken = auth.data;
                                    service.getCosCredential(url + serveName, auth.data, {}).then(res => {
                                        this.uploadFile(res.data, folder, fileObj, filename);
                                        service.killAuthentication(url + serveName, this.tmpToken, {}).then(kill => {
                                            console.log("kill", kill)
                                        })
                                    })
                                } else {
                                    Toast(auth.msg)
                                }
                            })
                        }
                        else if(origin==="m"){
                            service.getMinIOCredential(url + serveName, "", {
                                username: thirdApp,
                                password: thirdPWD
                            }).then(auth => {
                                if (auth.code == 200) {
                                    this.tmpToken = auth.data.xtoken;
                                    this.minioClient = new Minio.Client({
                                        endPoint: auth.data.endpoint,
                                        port: parseInt(auth.data.port),
                                        useSSL: true,
                                        accessKey: auth.data.ytoken,
                                        secretKey: auth.data.ztoken
                                    });
                                    this.uploadMinIOFile( auth.data.bucket,folder, fileObj, filename);
                                } else {
                                    Toast(auth.msg)
                                }
                            })

                        }

                    }
                    // alert("现在有"+this.base64List.length+"张图片")
                }
            },
            uploadFile(sign, folder, file, filename) {
                let _this = this
                // console.log("file",file)
                var bucket = process.env.VUE_APP_COS_BUCKET;
                var region = 'ap-shanghai';
                // var _this = this;
                var cos = new COS({
                    // 必选参数
                    getAuthorization: function (options, callback) {
                        callback({
                            TmpSecretId: sign.tmpSecretId,
                            TmpSecretKey: sign.tmpSecretKey,
                            XCosSecurityToken: sign.sessionToken,
                            StartTime: sign.startTime, // 时间戳，单位秒，如：1580000000
                            ExpiredTime: sign.expiredTime, // 时间戳，单位秒，如：1580000900
                        });
                    },
                });
                cos.putObject({
                        Bucket: bucket,
                        Region: region,
                        Key: folder + filename,
                        StorageClass: 'STANDARD',
                        Body: file,
                        onProgress: function (progressData) {
                            console.log(JSON.stringify(progressData));
                        }
                    },
                    function () {
                        // let outnotifyOrderId=_this.getQueryVariable("outnotifyOrderId")
                        let outnotifyOrderId = _this.$route.params.outnotifyOrderId
                        let samplePath = folder + filename;
                        let url = process.env.VUE_APP_API;
                        let serveName = process.env.VUE_APP_NAME;
                        let topic =  _this.$route.params.topic
                        service.addOutOrderImageG(url + serveName, {
                            topic:topic,
                            outnotifyOrderId: outnotifyOrderId,
                            orderImgUrl: samplePath
                        }).then((res) => {
                            if (res.code == "200") {
                                _this.uploadLoading = false
                                _this.base64List = [require('../../assets/image/addimgbg.jpg'),]
                                service.killAuthentication(url + serveName, this.tmpToken, {}).then(kill => {
                                    console.log("kill", kill)
                                })
                                Toast("图片上传成功");
                            } else {
                                _this.uploadLoading = false
                                Toast("图片上传失败");
                            }
                        });
                        //参数（err, data）
                        // console.log("err",err)
                        // console.log("data",data)
                        // let path = 'https://' + bucket + '.cos.ap-shanghai.myqcloud.com' + folder + '' + filename + ''
                        // console.log("path",path)
                        // getPath({key:folder + filename}).then(res=>{
                        //     // console.log(res);
                        //     let file = [ {
                        //         uid: '-1',
                        //         name: folder + filename,
                        //         status: 'done',
                        //         url: res.data.data,
                        //     }]
                        //     _this.attachment=file;
                        //     _this.contract.attach= folder + filename;
                        //     _this.uploading = false;
                        // })
                    });
            },
            uploadMinIOFile(bucket,folder, file, filename) {
                let fr = new FileReader();//用FileReader 读取文件流
                fr.readAsArrayBuffer(file);
                fr.addEventListener("loadend",e=>{
                    //e.target.result 就是读取到的文件流 将其转为Buffer类型即可
                    let _this = this;

                    this.minioClient.putObject(bucket, folder+filename, new Buffer(e.target.result), file.size, function(err, objInfo) {
                        if(err) {
                            return console.log(err); // err should be null
                        }
                        console.log(objInfo)
                        let outnotifyOrderId = _this.$route.params.outnotifyOrderId
                        let samplePath = folder + filename;
                        let url = process.env.VUE_APP_API;
                        let serveName = process.env.VUE_APP_NAME;
                        let topic =  _this.$route.params.topic
                        service.addOutOrderImageG(url + serveName, {
                            topic:topic,
                            outnotifyOrderId: outnotifyOrderId,
                            orderImgUrl: samplePath
                        }).then((res) => {
                            if (res.code == "200") {
                                _this.uploadLoading = false
                                _this.base64List = [require('../../assets/image/addimgbg.jpg'),]
                                Toast("图片上传成功");
                            } else {
                                _this.uploadLoading = false
                                Toast("图片上传失败");
                            }
                        });

                    })
                })
            },
            getQueryVariable(variable) {
                var query = window.location.search.substring(1);
                var vars = query.split("&");
                for (var i = 0; i < vars.length; i++) {
                    var pair = vars[i].split("=");
                    if (pair[0] == variable) {
                        return pair[1];
                    }
                }
                return (false);
            },
            dataURLtoFile(dataurl, filename) {
                var arr = dataurl.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {type: mime});
            }
        }
    }
</script>

<style scoped>
    .btn_view {
        position: fixed;
        /*padding-left: 5px;*/
        /*padding-right: 5px;*/
        bottom: 0px;
        height: 60px;
        width: 100% !important;
        /*font-size: 12px;*/
        z-index: 9999;
        box-sizing: border-box;
    }

    .demo-lazyload {
        position: relative;
    }

    .demo-lazyload .van-image {
        box-sizing: border-box;
        margin-bottom: 12px;
        padding: 12px;
        background-color: white;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        border-radius: 12px;
    }

    .van-badge--fixed {
        position: absolute;
        top: 10px;
        right: 20px;
        -webkit-transform: translate(50%, -50%);
        transform: translate(50%, -50%);
        -webkit-transform-origin: 100%;
        transform-origin: 100%;
        color: #6685a4;
    }

    .van-badge {
        display: inline-block;
        box-sizing: border-box;
        min-width: 16px;
        padding: 0 3px;
        color: #fff;
        font-weight: 500;
        font-size: 12px;
        line-height: 18px;
        text-align: center;
        background-color: #6685a4;
        border: 1px solid #fff;
        border-radius: 10px;
    }

    .searchwarp {
        margin-top: 0px;
        height: calc(100vh - 70px);
        overflow: auto;
    }

    .van-list .van-cell__title {
        text-align: left;
    }

    /deep/ .van-cell__title {
        text-align: left;
        -webkit-box-flex: unset;
        -webkit-flex: unset;
        flex: unset;
    }

    .van-panel__content {
        padding: 10px 16px;
        text-align: left;
        font-size: 16px;
    }

    .zxlb::after {
        border-bottom: 1px solid #ebedf0;
    }

    .zxlb {
        margin: 0px 8px 20px 8px;
        overflow: hidden;
        border-radius: 8px;
        display: block;
        background: #f7f8fa url('../../assets/image/rhzxbg.png') no-repeat top;
        background-size: 100% 100%;
        border: 1px solid #6ea7af;

    }

    /deep/ .zxlb .van-cell {
        padding: 10px 10px 10px 10px;
        background: transparent;
    }

    .van-cell__value.van-cell__value--alone {
        background: #fff;
        padding: 8px 8px;
        border-radius: 8px;
    }

    .newstime {
        color: #fff;
        font-weight: normal;
        font-size: 12px;
        padding: 20px 0 8px 0;
        border-bottom: 1px solid rgba(255, 255, 255, 0.3);
        margin: 0 20px;
        vertical-align: bottom;
        text-align: left;
    }

    .van-cell::after {
        border-bottom: 0
    }

    .content >>> img {
        max-width: 100%;
    }
</style>
